import { render, staticRenderFns } from "./IconSvgUnknown.vue?vue&type=template&id=af4ddac0&scoped=true&"
import script from "./IconSvgUnknown.vue?vue&type=script&lang=js&"
export * from "./IconSvgUnknown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4ddac0",
  null
  
)

export default component.exports